import { IResponse } from "../@types/commonTypes";
import { HeApiResponse, Plan } from "../@types/landingJcTypes";
import { ApiName } from "../Constant/ApiName";
import { getRequest, postRequest } from "./NetworkService";

const getArtworkApiUrl = () => {
  return "https://landingartwork.trivia.mobi/api/artwork";
  // return window.location.protocol === "http:"
  //   ? base.replace("https://", "http://")
  //   : base;
};

export const getArtworkService = async (
  utmCampaign: string,
): Promise<IResponse<{ url: string }> | null> => {
  const response = await fetch(
    `${getArtworkApiUrl()}?identifier=jhoom&param_name=${encodeURIComponent(utmCampaign)}`,
    { headers: { Accept: "application/json" } },
  );
  if (!response.ok) return null;
  const json = await response.json();
  // API returns { success, data, message } — normalize to IResponse shape
  if (json.success && json.data) {
    return { status: 0, result: json.data, message: json.message };
  }
  return json as IResponse<{ url: string }>;
};

export const getPlanService = async (
  planId?: number,
): Promise<IResponse<Plan>> => {
  const endPoint =
    planId !== undefined && planId > 0
      ? `${ApiName.getPlan}?planId=${planId}`
      : ApiName.getPlan;

  const { data }: { data: IResponse<Plan> } = await getRequest(endPoint);

  return data;
};

export const getEnrichmentService = async (): Promise<HeApiResponse> => {
  let endPoint = ApiName.he;
  let { data }: { data: HeApiResponse } = await postRequest(endPoint, "");
  return data;
};

export const checkUserService = async (msisdn: string) => {
  let endPoint = `${ApiName.checkJCUser}/${msisdn}`;
  let { data }: { data: IResponse<boolean> } = await getRequest(endPoint);
  return data;
};
